/**
 * Displays the application version with optional git hash.
 * Version is injected at build time via Vite define.
 */
export function AppVersion() {
  return (
    <p>
      Dice Frog v{__APP_VERSION__}
      {__GIT_HASH__ !== 'local' && (
        <span className="text-muted-foreground/60 ml-1">({__GIT_HASH__})</span>
      )}
    </p>
  );
}
